<div class="consumer-finance-application-details-component">
  <div fxLayout="column" fxLayoutGap="5px">
    <div>
      <breadcrumb (events)="onBreadcurmbEvents($event)" [trails]="breadcrumbTrails"></breadcrumb>
    </div>
    <div class="separator-bottom row">
      <div class="col-lg-8 col-md-12 mb-1" fxLayout="row" fxLayoutAlign="space-between center">
        <button mat-flat-button class="mat-flat-button-custom w-lt-md-100 btn-black-border">
          <application-type-icon applicationType="Consumer" />
          Consumer Asset Finance
          @if (application.Source == 'external') {
            <span class="ml-2 mdi mdi-alpha-e-circle" matTooltip="External source application"></span>
          }
          @if (application.Source == 'direct') {
            <span class="ml-2 mdi mdi-alpha-d-circle" matTooltip="Direct source application"></span>
          }
        </button>
      </div>
      <div class="col-lg-4 col-md-12 mb-1">
        <application-stage-icon [stage]="getApplicationStage(application)"></application-stage-icon>
      </div>
    </div>
  </div>
  <mat-tab-group
    [mat-stretch-tabs]="false"
    mat-align-tabs="start"
    [(selectedIndex)]="currentSectionIndex"
    (selectedTabChange)="onSelectedTabChange($event)">
    @for (currentTab of tabs; track currentTab) {
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="mdi {{currentTab.iconClass}}"> </span>
          {{currentTab.name}}
        </ng-template>
      </mat-tab>
    }
  </mat-tab-group>
  @if (currentSection === 'asset') {
    <div class="row">
      <div
        class="col-md-12 btn-space header"
        fxLayoutGap="10px"
        fxLayout="row"
        fxLayoutAlign="end center"
        fxLayout.lt-md="column"
        fxLayoutAlign.lt-md="center start"
        >
        <button mat-flat-button (click)="showAddAsset()" [disabled]="isSettledLoan">
          <span class="mdi mdi-plus" matPrefix></span>
          <span class="label"> Add Asset </span>
        </button>
        @if (currentSection === 'asset') {
          <button mat-flat-button [matMenuTriggerFor]="menu" [disabled]="isAssetEmpty">
            <span class="label">  PPSR </span> <span class="mdi mdi-chevron-down" matPrefix></span>
          </button>
        }
        <mat-menu #menu="matMenu">
          <button class="menu-items" mat-menu-item (click)="onPPSRCheckAll($event)">
            <div fxLayout="row" fxLayoutAlign="space-between center">
              <div>Check All</div>
              <div><span class="mdi mdi-autorenew"></span></div>
            </div>
          </button>
        </mat-menu>
        @if (activeContract && allowContractGeneration) {
          <button mat-flat-button (click)="openContractStatusDialog()">
            <span class="mdi mdi-account-supervisor-outline pr-2" matPrefix></span>
            <span class="label">Signer Status</span>
          </button>
        }
        @if (currentSection === 'asset') {
          <button mat-flat-button
            [disabled]="isAssetEmpty || (allAssetAccepted && isInternalUser(loggedInUser))  || !applicationStageAllowSettleLoan(application) || (missingBankDetails && isInternalUser(loggedInUser))"
            (click)="onSettleLoan()">
            <span class="mdi mdi-cash-multiple pr-2" matPrefix></span>
            <span class="label">Request Settlement</span>
          </button>
        }
      </div>
    </div>
  }
  <div>
    @if (currentSection === 'asset' && missingBankDetails && isInternalUser(loggedInUser)) {
      <message-box type="danger">
        Cannot request settlement as {{missingBankDetails}}'s bank details are missing.
      </message-box>
    }
    @if (currentSection === 'app') {
      <consumer-app
        [getUsersInCompanyFn]="getUsersInCompanyFn"
        [getUserFn]="getUserFn"
        [withdrawApplicationFn]="withdrawApplicationFn"
        (events)="events.emit($event)"
        (navigateToApplications)="navigateToApplications.emit()"
        [application]="application"
        [getAggregatorsAndOriginatorsFn]="getAggregatorsAndOriginatorsFn"
        [getUserByAccessLevelFn]="getUserByAccessLevelFn"
        [getApplicationSettlementsOfficerFn]="getApplicationSettlementsOfficerFn"
        [getAmlOfficerCandidatesFn]="getAmlOfficerCandidatesFn">
      </consumer-app>
    }
    @if (currentSection === 'bank-statement') {
      <bank
        [refreshBankStatementFn]="refreshBankStatementFn"
        [getBankStatementsAnalysisFn]="getBankStatementsAnalysisFn"
        [apiUrl]="apiUrl"
        [bankStatementsUrl]="bankStatementsUrl"
        [getBsaLenderListFn]="getBsaLenderListFn"
        [getBsaExcludedLenderListFn]="getBsaExcludedLenderListFn"
        [updateDscrCalculatorValueFn]="updateDscrCalculatorValueFn"
        [getDscrCalculatorValueFn]="getDscrCalculatorValueFn"
        [saveBsaCalculatorFn]="saveBsaCalculatorFn"
        [getBsaCalculatorFn]="getBsaCalculatorFn"
        [getNotesByApplicationIdFn]="getNotesByApplicationIdFn"
        [createApplicationNoteFn]="createApplicationNoteFn"
        [removeApplicationNoteByNoteIdFn]="removeApplicationNoteByNoteIdFn"
        [getDscrCalculatorHistoryFn]="getDscrCalculatorHistoryFn"
        [getBasiqCustomerMappingByAbnFn]="getBasiqCustomerMappingByAbnFn"
        [getBasiqStatementDataForCompanyFn]="getBasiqStatementDataForCompanyFn"
        [refreshBasiqConnectionsFn]="refreshBasiqConnectionsFn"
        [getBankStatementAndBasiqDataStatusFn]="getBankStatementAndBasiqDataStatusFn"
      [application]="application"></bank>
    }
    @if (currentSection === 'asset') {
      <asset-settlement
        [getApplicationPpsrInfoFn]="getApplicationPpsrInfoFn"
        [removeApplicationAssetFn]="removeApplicationAssetFn"
        [downloadApplicationDocumentUrlFn]="downloadApplicationDocumentUrlFn"
        [searchAssetFn]="searchAssetFn"
        [getApplicationAssetFn]="getApplicationAssetFn"
        [sendAssetToSfFn]="sendAssetToSfFn"
        [getPpsrDetailsFn]="getPpsrDetailsFn"
        [addPpsrDetailFn]="addPpsrDetailFn"
        [updatePpsrDetailFn]="updatePpsrDetailFn"
        [updateApplicationAssetsFn]="updateApplicationAssetsFn"
        [submitApplicationAssetsFn]="submitApplicationAssetsFn"
        [searchGrantorsFn]="searchGrantorsFn"
        [getPpsrDocumentsFn]="getPpsrDocumentsFn"
        [searchSupplierFn]="searchSupplierFn"
        [saveSupplierFn]="saveSupplierFn"
        [businessSearchFn]="businessSearchFn"
        [apiUrl]="apiUrl"
        [application]="application"
        [isPpsrChecked]="ppsrChecked"
        [isPpsrRegistered]="ppsrRegistered"
        [getApplicationAuditLogsFn]="getApplicationAuditLogsFn"
        [getNotesByApplicationIdFn]="getNotesByApplicationIdFn"
        [sendToSF]="sendToSF"
        [assetSettlementSearchAssetsFn]="assetSettlementSearchAssetsFn"
        [listApplicationDocumentFn]="listApplicationDocumentFn"
        [createApplicationNoteFn]="createApplicationNoteFn"
        [removeApplicationNoteByNoteIdFn]="removeApplicationNoteByNoteIdFn"
        [createNewDisbursementFn]="createNewDisbursementFn"
        [updateDisbursementFn]="updateDisbursementFn"
        [getDisbursementByApplicationIdFn]="getDisbursementByApplicationIdFn"
        [syncDisbursementToSfFn]="syncDisbursementToSfFn"
        [paymentChartData]="paymentChartData"
        [syncBankDetailsToSfFn]="syncBankDetailsToSfFn"
        [syncPrivateSellerBankDetailsToSfFn]="syncPrivateSellerBankDetailsToSfFn"
        [syncDepositPaidToSfFn]="syncDepositPaidToSfFn"
        [getBillerNameFn]="getBillerNameFn"
        [getInstitutionNameFn]="getInstitutionNameFn"
        [validateBpayFn]="validateBpayFn"
        [createAssetInspectionFn]="createAssetInspectionFn"
        [getAssetInspectionsForApplicationFn]="getAssetInspectionsForApplicationFn"
        [downloadVerimotoReportFn]="downloadVerimotoReportFn"
        [assetInspectionTableData]="assetInspectionTableData"
        [verimotoLender]="verimotoLender"
        [verimotoAssetInspectionTypes]="verimotoAssetInspectionTypes"
        [addAuditLogFn]="addAuditLogFn"
        (onEditAssetEvent)="onEditAssetEvent($event)"
        (emptyAsset)="emptyAssetFn($event)"
        (settleLoan)="disableSettleLoan($event)"
        (ppsrStatus)="disableOnPPSRStatus($event)"
        (deleteAsset)="getApplicationAsset()"
        (newAssetInspection)="loadAssetInspections()"
        >
      </asset-settlement>
    }

    @if (currentSection === 'add-asset') {
      <add-asset
        [updateApplicationAssetsFn]="updateApplicationAssetsFn"
        [submitApplicationAssetsFn]="submitApplicationAssetsFn"
        [updateDocumentMetadataFn]="updateDocumentMetadataFn"
        [uploadApplicationDocumentFn]="uploadApplicationDocumentFn"
        [searchSupplierFn]="searchSupplierFn"
        [businessSearchFn]="businessSearchFn"
        [application]="application"
        [getPpsrDetailsFn]="getPpsrDetailsFn"
        [editAssetValue]="editAssetValue"
        [getInstitutionNameFn]="getInstitutionNameFn"
        [getApplicationAssetFn]="getApplicationAssetFn"
        [extractTaxInvoiceFn]="extractTaxInvoiceFn"
        [createAssetInspectionFn]="createAssetInspectionFn"
        [verimotoLender]="verimotoLender"
        [getContractStatusFn]="getContractStatusFn"
        [assetInspectionTableData]="assetInspectionTableData"
        (onBackClick)="getEvent()"
        (onAssetSave)="getAssetSave()"
        (onAssetInspectionCreated)="loadAssetInspections()">
      </add-asset>
    }
    @if (currentSection === 'kyc-aml') {
      <kyc-verification
        [getOriginatorByIdFn]="getOriginatorByIdFn"
        [addIndividualFn]="addIndividualFn"
        [businessSearchFn]="businessSearchFn"
        [verifyOneApplicationIndividualFn]="verifyOneApplicationIndividualFn"
        [sendVerificationSmsFn]="sendVerificationSmsFn"
        [getApplicationIndividualsFn]="getApplicationIndividualsFn"
        [saveApplicationPartiesFn]="saveApplicationPartiesFn"
        [updateApplicationIndividualDigitalIdMappingFn]="updateApplicationIndividualDigitalIdMappingFn"
      [updateIndividualKycStatusFn]="updateIndividualKycStatusFn"
      [syncIndividualKycFromFrankieOneFn]="syncIndividualKycFromFrankieOneFn"
      [businessNumberSearchFn]="businessNumberSearchFn"
        [downloadDocumentFromAzureFn]="downloadDocumentFromAzureFn"
        [uploadApplicationDocumentFn]="uploadApplicationDocumentFn"
        [listApplicationDocumentFn]="listApplicationDocumentFn"
        [application]="application">
      </kyc-verification>
    }
    @if (currentSection === 'documents') {
      <consumer-documents
        [apiUrl]="apiUrl"
        [application]="application"
        [getApplicationByIdFn]="getApplicationByIdFn"
        [uploadApplicationDocumentFn]="uploadApplicationDocumentFn"
        [listApplicationDocumentFn]="listApplicationDocumentFn"
        [downloadApplicationDocumentUrlFn]="downloadApplicationDocumentUrlFn"
        [approveApplicationDocumentFn]="approveApplicationDocumentFn"
        [declineApplicationDocumentFn]="declineApplicationDocumentFn"
        [deleteApplicationDocumentFn]="deleteApplicationDocumentFn"
        [downloadAllApplicationDocumentUrlFn]="downloadAllApplicationDocumentUrlFn"
        [updateApplicationDocumentTagsFn]="updateApplicationDocumentTagsFn"
        [updateApplicationRequiredDocumentsFn]="updateApplicationRequiredDocumentsFn"
         
        [createDocumentWorklistFn]="createDocumentWorklistFn"
        [completeDocumentWorklistFn]="completeDocumentWorklistFn"
        [getNotesByApplicationIdFn]="getNotesByApplicationIdFn"
        [getApplicationAuditLogsFn]="getApplicationAuditLogsFn"
        [createApplicationNoteFn]="createApplicationNoteFn"
        [removeApplicationNoteByNoteIdFn]="removeApplicationNoteByNoteIdFn"
        [generateApprovalNoticeFn]="generateApprovalNoticeFn"
        [sendApprovalNoticeEmailFn]="sendApprovalNoticeEmailFn"
        [deleteApprovalNoticeFileFn]="deleteApprovalNoticeFileFn"
        [undoApplicationDocumentFn]="undoApplicationDocumentFn"
        [updateApplicationStageFn]="updateApplicationStageFn"
        [getUserFn]="getUserFn"
        [getUserByAccessLevelFn]="getUserByAccessLevelFn"
        [isAssetEmpty]="isAssetEmpty"
        [notAllAssetAccepted]="allAssetAccepted"
        [missingBankDetails]="missingBankDetails"
        [updateApplicationStageFn]="updateApplicationStageFn"
        [getApplicationAssetFn]="getApplicationAssetFn"
        [getDisbursementByApplicationIdFn]="getDisbursementByApplicationIdFn"
        [settleLoanFn]="settleLoanFn"
      ></consumer-documents>
    }
    @if (currentSection === 'credit') {
      <consumer-credit
        [application]="application"
        [runCreditFlowFn]="runCreditFlowFn"
        [getCreditWebServicesFn]="getCreditWebServicesFn"
        [getApplicationCreditFlowResultFn]="getApplicationCreditFlowResultFn"
        [downloadCreditorWatchReportFn]="downloadCreditorWatchReportFn"
        [updateCreditStatusFn]="updateCreditStatusFn"
        [updateCreditOfficerFn]="updateCreditOfficerFn"
        [getActiveCreditUsersFn]="getActiveCreditUsersFn"
        [getCreditAuditLogFn]="getCreditAuditLogFn"
        [getApplicationByIdFn]="getApplicationByIdFn"
        [getDuplicatedApplicationsFn]="getDuplicatedApplicationsFn"
        [deleteWebServicesFn]="deleteWebServicesFn"
        [apiUrl]="apiUrl"
        [requestMoreInformationFn]="requestMoreInformationFn"
        [getUserFn]="getUserFn"
        [getApplicationAuditLogsFn]="getApplicationAuditLogsFn"
        [getNotesByApplicationIdFn]="getNotesByApplicationIdFn"
        [createApplicationNoteFn]="createApplicationNoteFn"
        [removeApplicationNoteByNoteIdFn]="removeApplicationNoteByNoteIdFn"
        [getApplicationDscrFn]="getApplicationDscrFn"
        [getHistoricalContractsFn]="getHistoricalContractsFn"
        [getPismoContractsFn]="getPismoContractsFn"
        (viewReport)="onViewReport($event)"
        (clickApplicationEvent)="onClick($event)"
        (refreshCreditTabEvent)="refreshCreditTab($event)"
      />
    }
    @if (currentSection === 'credit-report') {
      <credit-report
        [getWebServiceReportFn]="getWebServiceReportFn"
        [apiUrl]="apiUrl"
        (leaveCreditReport)="onLeaveReport($event)"
      ></credit-report>
    }
    @if (currentSection === 'pricing') {
      <consumer-pricing
        [application]="application">
      </consumer-pricing>
    }
  </div>
</div>
